export const createPostbackRepository = (appFetch) => {
    return {
        depositApplication(params = {}) {
            return appFetch.get('https://tracking.banki.ru/OPHwl', {params});
        },
    };
};
